function PageSelect(props) {
	const goBack = evt => {
		props.onChange(props.page - 1);
	};

	const goForward = evt => {
		props.onChange(props.page + 1);
	};

	return (<span>
		{props.page}/{props.pageCount}
		<button onClick={goBack} disabled={props.page === 1}>←</button>
		<button onClick={goForward} disabled={props.page === props.pageCount}>→</button>
	</span>);
}

export default PageSelect;
